(() => {
  let cataloguePromise;
  const root = window.Shopify?.routes?.root || '/';
  const catalogue = () => {
    if (cataloguePromise) return cataloguePromise;
    cataloguePromise = (async () => {
      const products = [];
      let pages = 1;
      for (let page = 1; page <= pages; page += 1) {
        const response = await fetch(`${root}collections/all?section_id=ferreti-ba26-catalog&page=${page}`, { cache: 'no-store' });
        if (!response.ok) throw new Error('No se pudo cargar el catálogo. Intenta de nuevo.');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = JSON.parse(html.querySelector('[data-ba26-catalog]').textContent);
        pages = data.pages;
        products.push(...data.products);
      }
      return Array.from(new Map(products.map(product => [product.id, product])).values());
    })().catch(error => { cataloguePromise = null; throw error; });
    return cataloguePromise;
  };
  const init = element => {
    if (element.dataset.ready === '1') return;
    element.dataset.ready = '1';
    const current = JSON.parse(element.querySelector('[data-ba26-current]').textContent);
    const eligible = element.dataset.eligible === 'true' && Date.now() < Date.parse('2026-12-01T07:59:00Z');
    const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'es', {
      style: 'currency', currency: element.dataset.currency || 'USD',
    }).format(amount / 100);
    let tier = 1;
    const selected = [{ ...current, variant: current.variants.find(variant => variant.id === current.selected) }, null, null];
    const submit = element.querySelector('[data-ba26-submit]');
    const error = element.querySelector('[data-ba26-error]');
    const picker = element.querySelector('[data-ba26-picker]');
    const sticky = document.querySelector(`[data-ferreti-sticky-cart][data-section-id="${element.dataset.section}"]`);
    const quantity = element.closest('product-info')?.querySelector('input[name="quantity"]') || element.querySelector('[data-ba26-quantity]');
    if (eligible && sticky) sticky.querySelector('.ferreti-sticky-cart__field--qty').hidden = true;
    let catalogueRows = [];
    let pickerSlot = 1;
    let page = 1;
    const renderSlots = () => {
      const slots = element.querySelector('[data-ba26-slots]');
      if (!slots) return;
      const selection = element.querySelector('[data-ba26-selection]');
      const panels = element.querySelectorAll('[data-ba26-panel]');
      panels.forEach(panel => { panel.hidden = Number(panel.dataset.ba26Panel) !== tier; });
      const activePanel = element.querySelector(`[data-ba26-panel="${tier}"]`);
      if (selection) {
        selection.hidden = tier === 1;
        if (activePanel) activePanel.append(selection);
      }
      slots.replaceChildren();
      for (let index = 0; index < tier; index += 1) {
        const choice = selected[index];
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ferreti-ba26-product__slot';
        if (choice) {
          const image = document.createElement('img');
          image.src = choice.image;
          image.alt = choice.title;
          image.width = 60; image.height = 60;
          button.append(image);
        }
        const text = document.createElement('span');
        text.textContent = choice ? choice.title.replace(/^FERRETI(?: HATS)?(?: PREMIUM)?\s*/i, '') : `Elige tu gorra ${index + 1}`;
        const small = document.createElement('small');
        small.textContent = choice ? `${choice.variant?.title || ''} · ${money(choice.variant?.price || 0)}${choice.variant?.available ? '' : ' · Agotada'}` : 'Todos los modelos y variantes disponibles';
        text.append(small); button.append(text);
        if (index === 0) {
          button.disabled = true;
          button.setAttribute('aria-label', 'Primera gorra: variante seleccionada en esta ficha');
        } else button.addEventListener('click', () => openPicker(index));
        slots.append(button);
      }
      element.querySelector('[data-ba26-benefits]').hidden = tier !== 3;
      const choices = selected.slice(0, tier);
      const complete = choices.every(choice => choice?.variant?.available);
      const missing = choices.filter(choice => !choice).length;
      element.querySelector('[data-ba26-estimate]').textContent = complete ?
        `Total estimado: ${money(window.FerretiBA26.selectionTotal(choices.map(choice => choice.variant.price)))}` :
        missing ? `${missing === 1 ? `Elige tu ${selected[1] ? 'tercera' : 'segunda'} gorra` : 'Elige tu segunda y tercera gorra'} para ver el total.` : 'La variante seleccionada está agotada.';
      submit.textContent = !selected[0]?.variant?.available ? 'VARIANTE AGOTADA' : complete ? 'AGREGAR AL CARRITO' : 'COMPLETA TU SELECCIÓN';
      submit.disabled = !complete;
      if (sticky) {
        sticky.querySelector('.ferreti-sticky-cart__price').textContent = complete ?
          money(window.FerretiBA26.selectionTotal(choices.map(choice => choice.variant.price))) : 'Completa tu selección';
        sticky.querySelector('.ferreti-sticky-cart__title').textContent = tier > 1 ?
          `Black Alucín · ${tier} gorras` : current.title;
      }
    };
    const renderPicker = () => {
      const query = picker.querySelector('[data-ba26-search]').value.trim().toLocaleLowerCase();
      const rows = catalogueRows.filter(product =>
        `${product.title} ${product.variants.map(variant => variant.title).join(' ')}`.toLocaleLowerCase().includes(query)
      );
      const pages = Math.max(1, Math.ceil(rows.length / 12));
      page = Math.min(page, pages);
      const grid = picker.querySelector('[data-ba26-grid]');
      grid.replaceChildren();
      rows.slice((page - 1) * 12, page * 12).forEach(product => {
        const card = document.createElement('article');
        card.className = 'ferreti-ba26-picker__card';
        const image = document.createElement('img');
        image.src = product.image; image.alt = product.title; image.loading = 'lazy';
        image.width = 200; image.height = 200;
        const title = document.createElement('h3'); title.textContent = product.title;
        const select = document.createElement('select');
        select.setAttribute('aria-label', `Variante de ${product.title}`);
        product.variants.forEach(variant => {
          const option = document.createElement('option'); option.value = String(variant.id);
          option.textContent = `${variant.title} · ${money(variant.price)}${variant.available ? '' : ' · Agotada'}`;
          option.disabled = !variant.available; select.append(option);
        });
        select.value = String(product.variants.find(variant => variant.available).id);
        const choose = document.createElement('button'); choose.type = 'button'; choose.textContent = 'ELEGIR GORRA';
        choose.addEventListener('click', () => {
          selected[pickerSlot] = { ...product, variant: product.variants.find(variant => String(variant.id) === select.value) };
          picker.close(); renderSlots();
        });
        card.append(image, title, select, choose); grid.append(card);
      });
      picker.querySelector('[data-ba26-page]').textContent = `${page} / ${pages}`;
      picker.querySelector('[data-ba26-prev]').disabled = page === 1;
      picker.querySelector('[data-ba26-next]').disabled = page === pages;
      picker.querySelector('[data-ba26-picker-status]').textContent = `${rows.length} modelos disponibles`;
    };
    const openPicker = async index => {
      pickerSlot = index; page = 1;
      picker.showModal();
      picker.querySelector('[data-ba26-picker-status]').textContent = 'Cargando todas las gorras…';
      try { catalogueRows = await catalogue(); renderPicker(); }
      catch (problem) { picker.querySelector('[data-ba26-picker-status]').textContent = problem.message; }
    };
    if (eligible && picker) {
      element.querySelectorAll('input[type="radio"]').forEach(radio => radio.addEventListener('change', () => {
        tier = Number(radio.value); error.textContent = ''; renderSlots();
      }));
      picker.querySelector('[data-ba26-close]').addEventListener('click', () => picker.close());
      picker.querySelector('[data-ba26-search]').addEventListener('input', () => { page = 1; renderPicker(); });
      picker.querySelector('[data-ba26-prev]').addEventListener('click', () => { page -= 1; renderPicker(); });
      picker.querySelector('[data-ba26-next]').addEventListener('click', () => { page += 1; renderPicker(); });
      renderSlots();
    } else {
      element.querySelector('[data-ba26-slots]')?.remove();
      element.querySelector('[data-ba26-estimate]')?.remove();
      element.querySelector('[data-ba26-benefits]')?.remove();
      element.querySelector('[data-ba26-terms]')?.remove();
      element.querySelector('.ferreti-ba26-product__tiers')?.remove();
      submit.disabled = !selected[0]?.variant?.available;
    }
    if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.variantChange, event => {
      if (event.data.sectionId !== element.dataset.section) return;
      const variant = event.data.variant;
      selected[0] = variant ? { ...current, variant } : null;
      if (eligible) renderSlots();
      else { submit.disabled = !variant?.available; submit.textContent = variant?.available ? 'AGREGAR AL CARRITO' : 'AGOTADO'; }
    });
    submit.addEventListener('click', async () => {
      error.textContent = '';
      const choices = selected.slice(0, eligible ? tier : 1);
      if (!choices.every(choice => choice?.variant?.available)) {
        error.textContent = 'Completa la selección con gorras disponibles.';
        element.scrollIntoView({ block: 'center', behavior: 'smooth' }); return;
      }
      submit.disabled = true;
      try {
        const drawer = document.querySelector('cart-drawer');
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
            items: choices.map(choice => ({ id: choice.variant.id, quantity: eligible ? 1 : Math.max(1, Number(quantity?.value) || 1) })),
            sections: drawer?.getSectionsToRender().map(section => section.id) || ['cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'No se pudo agregar la selección.');
        if (drawer) drawer.renderContents(result);
        const confirmed = await window.FerretiBA26.reconcile();
        if (!confirmed) error.textContent = 'Gorras agregadas. No pudimos confirmar el regalo; vuelve a intentar desde el carrito.';
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ba26-product', cartData: result });
        if (drawer) drawer.open(); else window.location.assign(`${root}cart`);
      } catch (problem) { error.textContent = problem.message; }
      finally { submit.disabled = !choices.every(choice => choice?.variant?.available); }
    });
  };
  const initialize = () => document.querySelectorAll('[data-ba26-product]').forEach(init);
  document.addEventListener('DOMContentLoaded', initialize, { once: true });
  document.addEventListener('shopify:section:load', initialize);
})();
